<template>
  <div>
    <div
      v-if="fullyLoaded"
      class="d-flex flex-column"
    >
      <v-row
        no-gutters
        class="mb-4 align-center"
      >
        <v-col class="col-6">
          <h5 class="text text-m-large-bold grey--text text--darken-1">Billing details</h5>
        </v-col>
        <v-col class="col-6 text-right">
          <v-btn
            v-if="!userSubscriptionCancelledAt || showUpdateBtnOnCheckout"
            text
            color="primary"
            class="heading heading-s-small px-0"
            @click="updateCard"
          >
            Update
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="mb-4"
      >
        <v-col class="col-6 d-flex flex-column">
          <h6 class="text text-m-small-regular grey--text text--darken-1 mb-1">Card number</h6>
          <p
            class="text text-l-small-bold mb-0"
            :class="[{ 'grey--text text--darken-4': !expireAlert }, { 'error--text text--error--base': expireAlert }]"
          >
            {{ cardNumber }}
          </p>
        </v-col>
        <v-col class="col-6 d-flex flex-column">
          <h6 class="text text-m-small-regular grey--text text--darken-1 mb-1">Expiration</h6>
          <p
            class="text text-l-small-bold mb-0"
            :class="[{ 'grey--text text--darken-4': !expireAlert }, { 'error--text text--error--base': expireAlert }]"
          >
            {{ cardExpiryDate }}
          </p>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="mb-4"
      >
        <v-col class="col-12 d-flex flex-column">
          <h6 class="text text-m-small-regular grey--text text--darken-1 mb-1">Cardholder name</h6>
          <p class="text text-l-small-bold grey--text text--darken-4 mb-0">
            {{ nameOnCard }}
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <h6 class="text text-m-small-regular grey--text text--darken-1 mb-1">Billing address</h6>
          <p class="text text-l-small-bold grey--text text--darken-4 mb-0">
            {{ fullAddress }}
          </p>
        </v-col>
      </v-row>
    </div>
    <ProgressBarComponent
      v-else
      :title="'card details'"
    />
  </div>
</template>

<script>
import ProgressBarComponent from '@/components/common/ProgressBarComponent';
export default {
  components: { ProgressBarComponent },
  props: {
    userSubscriptionCancelledAt: { default: null, type: String },
    expireAlert: { default: false, type: Boolean },
    cardNumber: { default: null, type: String },
    cardExpiryDate: { default: null, type: String },
    nameOnCard: { default: null, type: String },
    fullAddress: { default: null, type: String },
    showUpdateBtnOnCheckout: { default: false, type: Boolean },
    isLoadingForm: { default: false, type: Boolean },
  },
  computed: {
    fullyLoaded() {
      return this.cardNumber && this.cardExpiryDate && this.nameOnCard && this.fullAddress && !this.isLoadingForm;
    },
  },
  methods: {
    updateCard() {
      this.$emit('update-card');
    },
  },
};
</script>
